import { Stack, Card, Typography } from '@mui/material'
import { CustomIconWrapper, CustomIconWrapperProps } from './CustomIconWrapper'
import { JSX } from 'react'
import { TablerIcon } from '@tabler/icons-react'

export const OverviewCard = ({
  Icon,
  value,
  description,
  color,
  variant = 'elevation',
}: {
  Icon: TablerIcon
  value: JSX.Element
  description: string
  color: CustomIconWrapperProps['color']
  variant?: 'outlined' | 'elevation'
}) => {
  return (
    <Stack
      component={Card}
      elevation={0}
      variant={variant}
      direction="row"
      sx={{ px: 2, py: 1.5, alignItems: 'center', flexGrow: 1 }}
      spacing={2}
      useFlexGap
    >
      <CustomIconWrapper Icon={Icon} color={color} />
      <Stack>
        {value}
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Stack>
    </Stack>
  )
}
